import Button from '@/common/components/Button';
import { XCircleIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

interface OAuthErrorProps {
  errorResponse?: string;
}

const OAuthError = ({ errorResponse }: OAuthErrorProps) => {
  const navigate = useNavigate();

  return (
    <div className='flex flex-col items-center justify-center gap-8 h-96'>
      <XCircleIcon className='text-red-400 size-12' />

      <div className='flex flex-col items-center gap-2'>
        <p className='text-xl font-medium'>
          Falha na autenticação
        </p>

        <p className='italic font-light max-w-[680px] text-center'>
          {errorResponse || 'Não foi possível verificar suas credenciais. Verifique seus dados e tente novamente.'}
        </p>
      </div>

      <Button onClick={() => navigate('/login')}>
        Tentar novamente
      </Button>
    </div>
  )
}

export default OAuthError;
